<template >
  <el-dialog
    :title="'客户岗点'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-row>
      <el-col :span="12">
        <el-select clearable :disabled="deptdisable" @change="selectChanged3"   filterable   v-model="form.bmid"  placeholder="请选择大队">
          <el-option
                  v-for="item in depts"
                  :key="item.bmid"
                  :label="item.bmmc"
                  :value="item.bmid"
                  :disabled="deptdisable">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="12">
        <el-input
                @change="selectChanged3"
                @keyup.enter.native="selectChanged3"
                placeholder="请输入岗点名称"
                v-model="form.gdmc"
                clearable>
        </el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-table   :data="userList" ref="userTable" v-loading="loading" style="text-align: center; width: 100%;" :row-key="getRowKeys" @selection-change="selectionChangeHandle" @row-click="handleRowClick">
        <el-table-column
                type="selection"
                header-align="center"
                align="center"
                width="50"
                :reserve-selection="true"
                :selectable="canSelection"
        >
          <!--                -->
        </el-table-column>

        <el-table-column label="名称" prop="gdmc">
        </el-table-column>
        <el-table-column prop="zbjd" label="经度" width="120">
        </el-table-column>
        <el-table-column  prop="zbwd" label="纬度" width="120">
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="currentPage" background layout="total, prev, pager, next" :total="total" @current-change="pageUser" style="margin-top: 1rem;"></el-pagination>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
<el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>


  export default {
    data () {
      return {
        visible: false,
        totalPage: 0,
        currentPage: 1,
        id: 0,
        dataList:[],
        total:0,
        dataListSelections:[],
        depts:[],
        loading:false,
        useridList:[],
        userList:[],
        childDept:[],
        deptdisable:false,
        childdeptdisable:false,
        form:{
          bmid:'',
          gdmc: ''
        },
        bmxx:[],
        otherIds:[]
      }
    },
    created () {

    },
    methods: {
      init (id) {
        if(id){
          this.id =id
          this.dataList=[]
          this.currentPage=1;
          this.totalPage=0;
          this.userList=[]
          this.useridList=[]
          this.dataListSelections=[]
          this.form.bmid=''
          this.form.gdmc=''
          this.$request.get('/bjba/contract/userIdsList/'+this.id).then(res=> {
            this.useridList = res.data.data
            this.visible = true
            this.$nextTick(() => {
              this.$refs.userTable.clearSelection()
              this.getDepts()
            })

          })
          this.getOtherUser()
        }
      },
      getDepts() {
        let that = this;
        this.$request.get('/bjba/kqtj/getFirstMentForUser',{
          params: {
            userid:this.$store.getters.username
          }

        }).then(res => {
          that.depts = res.data
          if(this.depts && this.depts[0]) {
            var zzdyqc = this.$store.getters.user.zzdyqc;
            if(zzdyqc != this.CONST_ZN_BM) {
              var zw = this.$store.getters.user.zw;
              if(zw) {
                if(zw=='01'||zw=='02'||zw=='03') {
                  this.form.dept = that.depts[0].bmid
                  this.deptdisable = true
                }
              }
            }
          }
          this.getUserList();
        })
      },
      selectChanged3(value) {
        this.currentPage = 1;
        this.getUserList();


      },
      canSelection(row, rowIndex) {
    if (this.otherIds.some(item => item === row.gdid)) {
      return false
    } else {
      return true// 不禁用
    }
  },
      getRowKeys(row) {
        return row.gdid;
      },
      selectionChangeHandle (val) {
        console.log(val)
        this.dataListSelections = val
        if(val && val.length>0) {
          for(var i=0;i<val.length;i++) {
            var j =this.useridList.indexOf(val[i].gdid);
            if(j !== -1) {
              this.useridList.splice(j,1);
            }
          }
        }
      },
      handleRowClick(row, column, event){
        if (this.otherIds.some(item => item === row.gdid)) {
          return false
        } else {
          this.$refs.userTable.toggleRowSelection(row);
        }
      },
      getUserList: function () {
        this.loading = true
        this.form.page = this.currentPage;
        this.form.pagesize = 10
        this.$request({
          method: 'get',
          url: '/bjba/map/getGdPage',
          params:{
            page:this.currentPage,
            pagesize:this.pagesize,
            gdmc:this.form.gdmc,
            bmid:this.form.bmid
          }
        }).then((response) => {
          this.loading=false
          this.userList = response.data.content
          this.total = response.data.totalElements
          setTimeout(() => {
            this.setSelection()
          }, 50)
        })
      },
      getOtherUser() {
        this.$request.get('/bjba/contract/otherUserIdList/'+this.id).then(res=> {
          this.otherIds = res.data.data
        })
      },
      // 切换页码
      pageUser(page) {
        this.currentPage = page
        this.getUserList()
      },
      setSelection() {

        if (!this.useridList || this.useridList.length <= 0) {
          return
        }


        for (let i = 0; i < this.userList.length; i++) {
          if (this.useridList.indexOf(this.userList[i]['gdid']) >= 0) {
            this.$refs.userTable.toggleRowSelection(this.userList[i], true)
          }
        }

      },
      selectionChange(selection) {
        console.log(selection)
      },
      dataFormSubmit() {
      var data = {contractId:'',gdids:[]}
      data.contractId = this.id
      data.gdids =this.dataListSelections.map(item => {
        return item.gdid
      });
      if(this.useridList && this.useridList.length>0) {
        data.gdids = data.gdids.concat(this.useridList)
      }
      if(!data.gdids  || data.gdids.length <=0) {
        this.$message({
          message: '请选择岗点',
          type: 'warning',
          duration: 1500
        })
        return
      }
            this.$http({
              url: `/bjba/contract/setContractGdxx`,
              method: 'post',
              data: data
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.visible = false
                this.$emit('refreshDataList')
              }else if(data && data.code === 500) {
                this.$message({
                  message: data.message,
                  type: "error",
                  duration: 1500
                })
              }
            })

      }
    }
  }
</script>

<style lang="scss" >
  #left .el-form-item__content{
    text-align: left;
  }
  .menu-list__input,
  .icon-list__input {

    > .el-input__inner {
      cursor: pointer;
    }

  }

  .mod-menu__icon-popover {
    max-width: 350px;
  }

  .mod-menu__icon-list {
    max-height: 380px;
    padding: 0;
    margin: -8px 0 0 -8px;

    > .el-button {
      padding: 8px;
      margin: 8px 0 0 8px;

      > span {
        display: inline-block;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        font-size: 18px;
      }

    }
  }

  .icon-list__tips {
    font-size: 18px;
    text-align: center;
    color: #e6a23c;
    cursor: pointer;
  }
</style>
